export default __webpack_public_path__ + "static/media/loader.b4da088d.gif";